<template>
    <div class="text">
        <input type="text" :required="config.required" ref="input"
               class="tw-w-full tw-border-0 tw-border-b tw-bg-transparent focus:tw-outline-none focus:tw-ring-0"
               :style="inputStyles"
               :readonly="readonly"
               :value="value"
               @keyup="onAnswerInput" @paste="onAnswerInput">
    </div>
</template>

<script>
export default {
    name: 'QuestionShortText',
    props: {
        value: {
            type: String,
            default: ''
        },
        inputStyles: {
            type: Object,
        },
        readonly: {
            type: Boolean,
            default: false
        },
        config: {
            type: Object,
            required: true
        },
    },
    watch: {
        value: {
            handler(value) {
                this.answer(value);
            },
            immediate: true
        },
    },
    methods: {
        onAnswerInput(event) {
            this.answer(event.target.value);
        },
        answer(value) {
            this.$emit('answer', {
                value: value,
                valid: true,
            });
        }
    },
}
</script>
